/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'map-navigation/forward': {
    width: 16,
    height: 16,
    viewBox: '0 0 98 98',
    data: '<g data-name="Layer 2"><g data-name="Layer 1"><rect pid="0" width="98" height="98" rx="3.02" _fill="#373a36"/><path pid="1" d="M49 19.05l-24.74 23v13l19.8-18.41V73.5H54V36.66l19.75 18.41v-13z" _fill="#fff"/></g></g>'
  }
})
